import axios from "axios";
import { getAccessToken } from "utils/cookies";
import API_MAP from "../../constants/api";
import axiosClient from "../axiosClient";

class ApiManagerUsersSIP {
    search = (data) => {
        const { account, username, page } = data
        return axiosClient.get(API_MAP.MANAGER_USERS_SIP.SEARCH + `?account=${account || ''}&username=${username || ''}&page=${page + 1 || 1}`)
    }
    create = (data) => {
        return axiosClient.post(API_MAP.MANAGER_USERS_SIP.CREATE, data)
    }
    getById = (id) => {
        return axiosClient.get(API_MAP.MANAGER_USERS_SIP.GET_BY_ID+id)
    }
    update = (data) => {
        return axiosClient.post(API_MAP.MANAGER_USERS_SIP.UPDATE, data)
    }
    delete = (data) => {
        return axiosClient.post(API_MAP.MANAGER_USERS_SIP.DELETE, data)
    }
    updateStatus = (data) => {
        return axiosClient.post(API_MAP.MANAGER_USERS_SIP.UPDATE_STATUS, data)
    }
    uploadExcel = (data) => {
        return axios.post(API_MAP.UPLOAD_EXCEL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "token": getAccessToken()
            }
        })
    }
}

const apiManagerUsersSIP = new ApiManagerUsersSIP();

export default apiManagerUsersSIP;